// MD components helper — react-markdown overrides that render
// ```mermaid blocks as actual diagrams.
//
// Decision (Session 19N §N4): wrap react-markdown via `components={mdComponents}`
// override `code` to detect language-mermaid; pass everything else through.
// The MermaidBlock is lazy-loaded; pages without mermaid diagrams pay zero cost.

import type { Components } from 'react-markdown';
import { MermaidBlock } from './mermaid-block.js';

export const mdComponents: Components = {
  code: ({ className, children, ...rest }) => {
    const match = /language-(\w+)/.exec(className ?? '');
    const lang = match?.[1];
    const text = String(children).replace(/\n$/, '');
    if (lang === 'mermaid') {
      return <MermaidBlock source={text} />;
    }
    // Fallback to default rendering (inline `code` or fenced block).
    return <code className={className} {...rest}>{children}</code>;
  },
};
